import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartCommentResponse } from './multiCartMappers'

type GetCommentsResponse = paths['/api/carts/multi-carts/{multiCartId}/comments']['get']['responses']['200']['content']['application/json']

export async function getMultiCartComments(
  multiCartId: string,
  itemIds?: Array<string>,
  options?: { signal?: AbortSignal },
): Promise<Array<App.MultiCartComment>> {
  const queryString = itemIds?.length ? `?itemIds=${itemIds.join(',')}` : ''

  return request.get<GetCommentsResponse>(
    `/api/carts/multi-carts/${multiCartId}/comments${queryString}`,
    { credentials: 'include', signal: options?.signal },
  ).then(mapMultiCartCommentResponse)
}
